// Стили экрана диагностики механика (строкой, чтобы компонент без проблем грузился в SSR-проверках)
export const diagnosticStyles = `
.dg-page{min-height:100vh;background:#F3F5F9;padding-bottom:40px}
.dg-wrap{max-width:760px;margin:0 auto;box-sizing:border-box}

/* шапка заявки */
.dg-head{position:sticky;top:52px;z-index:40;background:rgba(255,255,255,.96);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);box-shadow:0 1px 0 #E6EAF1,0 6px 16px -12px rgba(16,24,40,.25)}
.dg-head-inner{padding:16px 16px 14px}
.dg-head-row{display:flex;align-items:center;gap:12px;min-width:0}
.dg-head-title{flex:1;min-width:0}
.dg-car{margin:0;font-size:13px;line-height:1.3;font-weight:700;color:#1A1A1A;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.dg-sub{display:flex;align-items:center;gap:6px;margin:7px 0 0;min-width:0;font-size:11px;color:#6B7280;white-space:nowrap;overflow:hidden}
.dg-sub>span{overflow:hidden;text-overflow:ellipsis}
.dg-sub a{flex-shrink:0;color:#374151;font-weight:600;text-decoration:none}
.dg-sub i{font-size:12px;color:#9CA3AF;margin-right:4px;vertical-align:-1px}
.dg-sub>span+span,.dg-sub>span+a{position:relative;padding-left:11px}
.dg-sub>span+span::before,.dg-sub>span+a::before{content:"";position:absolute;left:2px;top:50%;width:3px;height:3px;margin-top:-1.5px;border-radius:50%;background:#C5CCD8}
.dg-plate{flex-shrink:0;font-size:11px;font-weight:600;color:#374151;background:#FAFBFC;border:1px solid #D5DAE3;border-radius:5px;padding:1px 6px;line-height:16px;overflow:visible!important}
.dg-actions{display:flex;gap:6px;align-items:center;flex-shrink:0}
.dg-action{display:inline-flex;align-items:center;gap:5px;height:32px;padding:0 12px;border:0;border-radius:10px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap}
.dg-action i{font-size:15px}
.dg-action[data-tone=blue]{background:#EEF3FF;color:#0052FF}
.dg-action[data-tone=grey]{background:#F3F5F9;color:#6B7280}
.dg-action:disabled{cursor:not-allowed;opacity:.7}
.dg-badge{font-size:12px;font-weight:600;padding:4px 10px;border-radius:20px;white-space:nowrap}
.dg-progress{display:flex;align-items:center;gap:10px;margin-top:14px}
.dg-progress-bar{flex:1;height:6px;border-radius:3px;background:#EEF1F6;overflow:hidden}
.dg-progress-bar>div{height:100%;border-radius:3px;background:linear-gradient(90deg,#6E95FF,#0052FF);transition:width .3s}
.dg-progress-bar[data-full=true]>div{background:linear-gradient(90deg,#34D399,#059669)}
.dg-progress span{font-size:11px;font-weight:600;color:#6B7280;white-space:nowrap}

.dg-body{padding:16px;display:flex;flex-direction:column;gap:16px}

/* карточки */
.dg-card{background:white;border-radius:18px;padding:16px;box-shadow:0 1px 2px rgba(16,24,40,.04),0 4px 14px -6px rgba(16,24,40,.08);border:1.5px solid transparent}
.dg-card[data-missing=true]{border-color:#FCA5A5}
.dg-card-head{display:flex;align-items:flex-start;gap:10px;margin-bottom:12px}
.dg-card-title{margin:0;font-size:14px;font-weight:600;color:#1A1A1A}
.dg-card-sub{margin:2px 0 0;font-size:11px;line-height:1.45;color:#8892a4}
.dg-step{display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;border-radius:10px;background:#EEF3FF;color:#0052FF;font-size:16px}
.dg-step[data-done=true]{background:#E7F8F0;color:#059669}

.dg-input-wrap{position:relative;margin-bottom:10px}
.dg-input{width:100%;box-sizing:border-box;padding:10px 40px 10px 12px;border:1.5px solid transparent;border-radius:12px;background:#F3F5F9;font-size:14px;color:#1A1A1A;outline:none;transition:border-color .15s,background .15s}
.dg-input:focus{border-color:#A4BFFF;background:white}
.dg-input[data-error=true]{border-color:#FCA5A5;background:#FEF2F2}
.dg-input-wrap>span{position:absolute;right:12px;top:50%;transform:translateY(-50%);font-size:13px;color:#9CA3AF;pointer-events:none}

/* фото */
.dg-photos{padding:10px;border-radius:12px;background:#F7F8FA;border:1.5px dashed #DDE3EE}
.dg-photos[data-missing=true]{background:#FEF2F2;border-color:#FCA5A5}
.dg-photos+.dg-photos{margin-top:8px}
.dg-photos-title{display:flex;align-items:center;gap:5px;margin:0 0 8px;font-size:12px;font-weight:600;color:#374151}
.dg-photos-title i{font-size:14px;color:#6B7280}
.dg-photos[data-missing=true] .dg-photos-title,.dg-photos[data-missing=true] .dg-photos-title i{color:#DC2626}
.dg-retry{margin:0 0 8px;padding:0;border:0;background:none;color:#DC2626;font-size:11px;font-weight:600;cursor:pointer}
.dg-thumbs{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:8px}
.dg-thumb{position:relative;width:64px;height:64px}
.dg-thumb img{width:64px;height:64px;object-fit:cover;border-radius:10px;cursor:pointer;box-shadow:0 0 0 1px #E6EAF1}
.dg-thumb button{position:absolute;top:-6px;right:-6px;display:flex;align-items:center;justify-content:center;width:20px;height:20px;padding:0;border:2px solid white;border-radius:50%;background:#DC2626;color:white;cursor:pointer}
.dg-thumb button i{font-size:11px}
.dg-thumbs-ro img{width:80px;height:80px}
.dg-photo-buttons{display:grid;grid-template-columns:1fr 1fr;gap:6px}
.dg-photo-buttons button{display:flex;align-items:center;justify-content:center;gap:6px;padding:8px;border-radius:10px;font-size:12px;font-weight:600;cursor:pointer}
.dg-photo-buttons button i{font-size:15px}
.dg-photo-buttons .dg-gallery{background:white;border:1.5px solid #E6EAF1;color:#374151}
.dg-photo-buttons .dg-camera{background:#0052FF;border:1.5px solid #0052FF;color:white;box-shadow:0 6px 14px -10px rgba(0,82,255,.9)}
.dg-photos[data-missing=true] .dg-gallery{border-color:#FCA5A5}
.dg-photos[data-missing=true] .dg-camera{background:#DC2626;border-color:#DC2626}

.dg-primary{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;margin-top:12px;padding:12px;border:0;border-radius:12px;background:#0052FF;color:white;font-size:14px;font-weight:600;cursor:pointer;box-shadow:0 8px 18px -12px rgba(0,82,255,.9)}
.dg-primary:disabled{background:#E5E7EB;color:#9CA3AF;box-shadow:none;cursor:not-allowed}
.dg-confirmed{display:flex;align-items:center;gap:6px;margin-top:10px;padding:9px 12px;border-radius:12px;background:#E7F8F0;color:#059669;font-size:13px;font-weight:600}
.dg-confirmed i{font-size:16px}
.dg-mileage-value{margin:0 0 10px;font-size:20px;font-weight:700;color:#1A1A1A}

/* подсказки */
.dg-hints-loading{background:white;border-radius:18px;overflow:hidden;box-shadow:0 1px 2px rgba(16,24,40,.04),0 4px 14px -6px rgba(16,24,40,.08)}
.dg-hints-loading-row{display:flex;align-items:center;gap:10px;padding:12px 14px}
.dg-hints-icon{display:flex;align-items:center;justify-content:center;flex-shrink:0;width:32px;height:32px;border-radius:10px;background:linear-gradient(135deg,#EEF3FF,#F3EEFF);color:#0052FF}
.dg-hints-icon i{font-size:16px}
.dg-hints-error{display:flex;gap:8px;align-items:flex-start;padding:12px 14px;border-radius:14px;background:#FFF7ED;color:#9A3412;font-size:12px;line-height:1.5}
.dg-hints-error i{font-size:15px;color:#F59E0B;margin-top:1px}
.dg-locked-note{display:flex;align-items:center;gap:8px;padding:10px 12px;border-radius:14px;background:#EEF3FF;color:#3156B8;font-size:12px;font-weight:500}
.dg-locked-note i{font-size:16px;color:#0052FF}

/* группы чек-листа */
.dg-group{display:flex;flex-direction:column;gap:8px;transition:opacity .2s}
.dg-group[data-locked=true]{opacity:.45;pointer-events:none}
.dg-group-head{display:flex;align-items:center;gap:8px;margin:4px 0 2px}
.dg-group-icon{display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:8px;background:white;color:#0052FF;box-shadow:0 1px 2px rgba(16,24,40,.06)}
.dg-group[data-locked=true] .dg-group-icon{color:#9CA3AF}
.dg-group-icon i{font-size:15px}
.dg-group-head h2{flex:1;margin:0;font-size:11px;font-weight:700;color:#6B7280;text-transform:uppercase;letter-spacing:.08em}
.dg-group-count{font-size:11px;font-weight:600;color:#9CA3AF;padding:2px 8px;border-radius:999px;background:white}
.dg-group-count[data-full=true]{color:#059669;background:#E7F8F0}

/* пункт чек-листа */
.dg-item{position:relative;background:white;border-radius:16px;padding:14px 14px 14px 16px;box-shadow:0 1px 2px rgba(16,24,40,.04),0 4px 14px -6px rgba(16,24,40,.08);border:1.5px solid transparent}
.dg-item::before{content:"";position:absolute;left:0;top:14px;bottom:14px;width:3px;border-radius:0 3px 3px 0;background:var(--dg-accent,transparent);transition:background .2s}
.dg-item[data-state=ok]{--dg-accent:#10B981}
.dg-item[data-state=warning]{--dg-accent:#F59E0B}
.dg-item[data-state=critical]{--dg-accent:#DC2626}
.dg-item[data-state=na]{--dg-accent:#9CA3AF}
.dg-item[data-missing=true]{border-color:#FCA5A5}
.dg-item-title{margin:0 0 12px;font-size:13px;font-weight:600;color:#1A1A1A}
.dg-sides{display:flex;flex-direction:column;gap:12px}
.dg-side+.dg-side{padding-top:12px;border-top:1px dashed #E6EAF1}
.dg-side-label{display:inline-flex;align-items:center;gap:4px;margin:0 0 6px;padding:2px 8px;border-radius:999px;background:#F3F5F9;font-size:11px;font-weight:500;color:#6B7280}
.dg-side-label i{font-size:12px}

.dg-status-grid{display:grid;grid-template-columns:1fr 1fr;gap:6px}
.dg-status{--tone:#059669;--tint:#ECFDF5;display:flex;align-items:center;justify-content:center;gap:5px;padding:10px 6px;border-radius:10px;border:1.5px solid color-mix(in srgb,var(--tone) 28%,white);background:var(--tint);color:var(--tone);font-size:12px;font-weight:600;cursor:pointer;transition:background .15s,color .15s,box-shadow .15s,border-color .15s}
.dg-status i{font-size:14px}
.dg-status[data-tone=warning]{--tone:#D97706;--tint:#FFF8EB}
.dg-status[data-tone=critical]{--tone:#DC2626;--tint:#FEF2F2}
.dg-status[data-tone=na]{--tone:#6B7280;--tint:#F3F5F9}
.dg-status:hover{border-color:var(--tone)}
.dg-status[aria-pressed=true]{background:var(--tone);border-color:var(--tone);color:white;box-shadow:0 6px 14px -8px var(--tone)}
.dg-status:disabled{cursor:default}
.dg-status:disabled:not([aria-pressed=true]){opacity:.4}
.dg-status:disabled:hover{border-color:color-mix(in srgb,var(--tone) 28%,white)}
.dg-need{display:flex;align-items:center;gap:5px;margin-top:6px;padding:7px 10px;border-radius:10px;background:#FEF2F2;color:#DC2626;font-size:12px;font-weight:600}
.dg-need i{font-size:14px}
.dg-item .dg-photos{margin-top:8px}

.dg-conclusion{padding:0 16px 28px}
.dg-page button:focus-visible,.dg-page input:focus-visible,.dg-page textarea:focus-visible,.dg-page a:focus-visible{outline:2px solid #0052FF;outline-offset:2px}

/* экран «Взять в работу» */
.dg-take{min-height:100vh;background:#F3F5F9;overflow:hidden}
.dg-take-head{position:fixed;top:52px;left:0;right:0;z-index:40;background:white;box-shadow:0 1px 0 #E6EAF1}
.dg-take-head .dg-head-inner{display:flex;align-items:center;justify-content:space-between}
.dg-take-preview{filter:blur(6px);pointer-events:none;user-select:none;padding-top:112px}
.dg-take-shade{position:fixed;inset:0;z-index:10;background:rgba(15,23,42,.38)}
.dg-sheet{position:fixed;left:0;right:0;bottom:0;z-index:20;max-width:560px;margin:0 auto;box-sizing:border-box;padding:12px 16px calc(24px + env(safe-area-inset-bottom));border-radius:22px 22px 0 0;background:white;box-shadow:0 -10px 40px -12px rgba(16,24,40,.35)}
.dg-sheet-grip{width:36px;height:4px;margin:0 auto 14px;border-radius:2px;background:#D5DAE3}
.dg-sheet-car{margin:0 0 4px;font-size:17px;font-weight:700;color:#1A1A1A}
.dg-sheet-sub{display:flex;align-items:center;gap:6px;margin:0 0 16px;font-size:13px;color:#6B7280}
.dg-sheet-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:16px}
.dg-sheet-field{padding:10px 12px;border-radius:12px;background:#F3F5F9;min-width:0}
.dg-sheet-field p{margin:0;font-size:11px;color:#9CA3AF}
.dg-sheet-field b{display:block;margin-top:2px;font-size:13px;font-weight:600;color:#1A1A1A;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.dg-take-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:15px;border:0;border-radius:14px;background:#0052FF;color:white;font-size:15px;font-weight:700;cursor:pointer;box-shadow:0 8px 18px -10px rgba(0,82,255,.9)}
.dg-take-btn:disabled{background:#93AEFF;box-shadow:none;cursor:not-allowed}
.dg-take-btn i{font-size:18px}

@media(max-width:600px){
    .dg-body{padding:12px;gap:14px}
    .dg-conclusion{padding:0 12px 24px}
    .dg-card{padding:14px;border-radius:16px}
    .dg-head-inner{padding:14px 12px 12px}
}
@media(max-width:420px){
    .dg-action-label{display:none}
    .dg-action{width:32px;padding:0;justify-content:center}
}
@media(max-width:360px){.dg-status{font-size:11px;gap:3px}.dg-status i{display:none}}
@keyframes vibePulse{0%,100%{opacity:1}50%{opacity:.3}}
`
